import script from "./MfaCodeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MfaCodeModal.vue?vue&type=script&setup=true&lang=ts"

import "./MfaCodeModal.vue?vue&type=style&index=0&id=9550f2e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9550f2e6"]])

export default __exports__